import { createReducer, on } from "@ngrx/store";
import { loadAgreementFailure, loadAgreementsSucess, resetAgreement } from "./agreement.actions";

export const agreementFeatureKey = "agreement";

export interface AgreementState {
	agreement: string;
}

export const initialState: AgreementState = {
	agreement: undefined,
};

export const agreementReducer = createReducer(
	initialState,
	on(loadAgreementsSucess, (state, { data }) => ({
		...state,
		agreement: data,
	})),
	on(loadAgreementFailure, (state, action) => ({
		...state,
		loadingAgreementsError: action.error,
	})),

	on(resetAgreement, () => initialState)
);
